<template>
    <b-modal
        ref="modalEditDevice"
        title="Edit Device"
        title-tag="h2"
        :lazy="true"
        footer-class="d-flex"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        :busy="isSaving"
        @hide="reset"
    >
        <b-form-group label-for="devicesName" label="Device:" label-cols="3">
            <div class="p-2">
                {{ editableDevice.deviceName }}
            </div>
        </b-form-group>

        <b-form-group
            label-for="displayName"
            label-cols="3"
            label="Display Name:"
        >
            <b-input
                v-model="editableDevice.displayName"
                name="editableDevice.displayName"
                type="text"
                :placeholder="
                    editableDevice.isAnalyzer
                        ? 'Display Name (required)'
                        : 'Display Name (optional)'
                "
                :class="{
                    'border-danger':
                        editableDevice.isAnalyzer && !editableDevice.displayName
                }"
            />
        </b-form-group>

        <template #modal-footer>
            <loader v-if="isLoading" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="$refs.modalEditDevice.hide()"
                v-if="!isLoading"
            >
                Cancel
            </b-button>

            <b-button v-if="!isLoading" variant="primary" @click="save">
                Save
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import Loader from "@/module/commons/loader";
import DevicesListService from "@/services/setting/devices-list";
export default {
    components: {
        Loader
    },
    props: {
        device: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            isSaving: false,
            editableDevice: {},
            isLoading: false
            // devicesName: "",
            // displayName: ""
        };
    },
    watch: {
        device: {
            handler(newVal) {
                this.editableDevice = { ...newVal };
            },
            immediate: true
        }
    },
    methods: {
        open() {
            this.$refs.modalEditDevice.show();
        },
        reset() {
            this.editableDevice = {};
        },
        async save() {
            this.isSaving = true;
            this.isLoading = true;

            try {
                let response;
                // trim the display name before saving
                const trimmedDisplayName = this.editableDevice.displayName
                    ? this.editableDevice.displayName.trim()
                    : null;

                if (this.editableDevice.isAnalyzer) {
                    // payload for analyzer device
                    const payload = {
                        id: this.editableDevice.id,
                        clinic_display_name: trimmedDisplayName
                    };

                    response = await DevicesListService.saveAnalyzerDevice(
                        payload
                    );
                } else {
                    // payload for other devices
                    const payload = {
                        id: this.editableDevice.id,
                        source: this.editableDevice.source,
                        display_name: trimmedDisplayName
                    };

                    response = await DevicesListService.saveSettingsDevice(
                        payload
                    );
                }

                const resData = response?.data?.response || response?.data;

                if (
                    resData &&
                    (resData.state === 200 || resData.code === 200)
                ) {
                    const updatedDevice = {
                        ...this.editableDevice,
                        displayName:
                            trimmedDisplayName ||
                            this.editableDevice.deviceName,
                        display_name: trimmedDisplayName,
                        clinic_display_name: trimmedDisplayName,
                        status: this.editableDevice.status,
                        source: this.editableDevice.source
                    };
                    this.$emit("device-updated", updatedDevice);
                    this._message(resData.message, "success");
                    this.$refs.modalEditDevice.hide();
                } else {
                    this._message(resData?.message, "danger");
                }
            } catch (error) {
                this._message(error.message, "danger");
            } finally {
                this.isSaving = false;
                this.isLoading = false;
            }
        }
    }
};
</script>

<style scoped>
.form-group {
    margin-bottom: 1rem;
}
</style>
